import { Position } from "reactflow";
import {
  GOVERNANCE_NODE_STYLE,
  MANAGEMENT_NODE_STYLE,
  IMPLEMENTATION_GROUP_STYLE,
} from "../Styles/nodeStyles";

export const initialNodes = [
  // Data Governance Group
  {
    id: "dg-group",
    type: "group",
    data: { label: "Data Governance" },
    position: { x: 0, y: 0 },
    style: {
      width: 1400,
      height: 220,
      zIndex: -1,
    },
    draggable: false,
  },
  // Data Governance nodes
  {
    id: "governeye-setup",
    data: { label: "GovernEYE™ setup" },
    position: { x: 30, y: 80 },
    parentNode: "dg-group",
    extent: "parent",
    sourcePosition: Position.Right,
    targetPosition: Position.Left,
    style: GOVERNANCE_NODE_STYLE,
  },
  {
    id: "business-goals",
    data: { label: "Business goals" },
    position: { x: 240, y: 40 },
    parentNode: "dg-group",
    extent: "parent",
    sourcePosition: Position.Right,
    targetPosition: Position.Left,
    style: GOVERNANCE_NODE_STYLE,
  },
  {
    id: "dg-assessment",
    data: { label: "DG Assessment" },
    position: { x: 240, y: 130 },
    parentNode: "dg-group",
    extent: "parent",
    sourcePosition: Position.Right,
    targetPosition: Position.Left,
    style: GOVERNANCE_NODE_STYLE,
  },
  {
    id: "data-strategy",
    type: "custom",
    data: {
      label: "Data Strategy",
      style: GOVERNANCE_NODE_STYLE,
    },
    position: { x: 450, y: 80 },
    parentNode: "dg-group",
    extent: "parent",
    sourcePosition: Position.Right,
    targetPosition: Position.Left,
  },
  {
    id: "use-case-book",
    data: { label: "Use Case book" },
    position: { x: 640, y: 80 },
    parentNode: "dg-group",
    extent: "parent",
    sourcePosition: Position.Right,
    targetPosition: Position.Left,
    style: GOVERNANCE_NODE_STYLE,
  },
  {
    id: "uc-prioritized",
    type: "custom",
    data: {
      label: "UC prioritized",
      style: GOVERNANCE_NODE_STYLE,
    },
    position: { x: 830, y: 80 },
    parentNode: "dg-group",
    extent: "parent",
    sourcePosition: Position.Right,
    targetPosition: Position.Left,
  },
  {
    id: "data-catalog",
    type: "custom",
    data: {
      label: "Data catalog",
      style: GOVERNANCE_NODE_STYLE,
    },
    position: { x: 1020, y: 80 },
    parentNode: "dg-group",
    extent: "parent",
    sourcePosition: Position.Right,
    targetPosition: Position.Left,
  },
  {
    id: "data-quality",
    type: "custom",
    data: {
      label: "Data Quality",
      style: GOVERNANCE_NODE_STYLE,
    },
    position: { x: 1210, y: 80 },
    parentNode: "dg-group",
    extent: "parent",
    sourcePosition: Position.Right,
    targetPosition: Position.Left,
  },

  // Data Management Group
  {
    id: "dm-group",
    type: "group",
    data: { label: "Data Management", color: "#0D2E4D" },
    position: { x: 0, y: 300 },
    style: {
      width: 1400,
      height: 300,
      zIndex: -1,
    },
    draggable: false,
  },

  // Data Management nodes
  {
    id: "skeye-setup",
    type: "custom",
    data: {
      label: "SKEYE™ setup",
      style: MANAGEMENT_NODE_STYLE,
    },
    position: { x: 420, y: 110 },
    parentNode: "dm-group",
    extent: "parent",
  },
  {
    id: "eda",
    type: "custom",
    data: {
      label: "EDA",
      style: MANAGEMENT_NODE_STYLE,
    },
    position: { x: 800, y: 110 },
    parentNode: "dm-group",
    extent: "parent",
  },

  // Implementation group
  {
    id: "implementation-group",
    type: "custom",
    data: {
      label: "",
      style: IMPLEMENTATION_GROUP_STYLE,
    },
    position: { x: 970, y: 30 },
    parentNode: "dm-group",
    extent: "parent",
    draggable: false,
  },
  {
    id: "implementation",
    data: { label: "Implementation" },
    position: { x: 20, y: 80 },
    parentNode: "implementation-group",
    extent: "parent",
    sourcePosition: Position.Right,
    targetPosition: Position.Left,
    style: MANAGEMENT_NODE_STYLE,
  },
  {
    id: "dashboarding",
    data: { label: "Dashboarding" },
    position: { x: 220, y: 20 },
    parentNode: "implementation-group",
    extent: "parent",
    sourcePosition: Position.Right,
    targetPosition: Position.Left,
    style: MANAGEMENT_NODE_STYLE,
  },
  {
    id: "predictive-analytics",
    data: { label: "Predictive\nanalytics" },
    position: { x: 220, y: 130 },
    parentNode: "implementation-group",
    extent: "parent",
    sourcePosition: Position.Right,
    targetPosition: Position.Left,
    style: {
      ...MANAGEMENT_NODE_STYLE,
      whiteSpace: "pre-line",
      textAlign: "center",
    },
  },
];
